import { p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
const tag = React__default.memo(function Tag(props) {
  let { id, SVs, children } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  let open = "<";
  let close = ">";
  if (SVs.selfClosed) {
    close = "/>";
  } else if (SVs.closing) {
    open = "</";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("code", { id, className: "doenet-tag", children: [
    open,
    children,
    close
  ] });
});
export {
  tag as default
};
